import Vue from 'vue'
import { URL_USER } from '@/constants/urls.js'
import { CURRENT_USER_EXPIRATIONS_DATES, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [CURRENT_USER_EXPIRATIONS_DATES.STATE.DOCUMENT_EXPIRATION_DATE]: null,
  [CURRENT_USER_EXPIRATIONS_DATES.STATE.CONTRACT_EXPIRATION_DATE]: null,
  [CURRENT_USER_EXPIRATIONS_DATES.STATE.TOTAL_EXPIRATION_DATE]: null
}

const actions = {
  async [CURRENT_USER_EXPIRATIONS_DATES.ACTIONS.GET_EXPIRATION_DATES] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER}/expirationDates?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(CURRENT_USER_EXPIRATIONS_DATES.MUTATIONS.GET_EXPIRATION_DATES, resp.data)
  },
  async [CURRENT_USER_EXPIRATIONS_DATES.ACTIONS.CLEAR_EXPIRATION_DATES] ({ commit }) {
    commit(CURRENT_USER_EXPIRATIONS_DATES.MUTATIONS.CLEAR_EXPIRATION_DATES)
  }
}

const mutations = {
  [CURRENT_USER_EXPIRATIONS_DATES.MUTATIONS.GET_EXPIRATION_DATES] (state, model) {
    for (const key in state) {
      state[key] = model[key]
    }
  },
  [CURRENT_USER_EXPIRATIONS_DATES.MUTATIONS.CLEAR_EXPIRATION_DATES] (state) {
    for (const key in state) {
      state[key] = null
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
